import { render, staticRenderFns } from "./_userProfile.vue?vue&type=template&id=f11fb160&lang=pug&"
import script from "./_userProfile.vue?vue&type=script&lang=js&"
export * from "./_userProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports